import {
  getUnitMap,
  getEntityTargetInfo,
  getUnitGroupList,
  getUnitGroup,
  getGroups,
  getUnitIds,
} from './selectors'
import * as entityApi from 'api/entity-api'

import {
  // WINDOW_SIZE_CHANGE,
  STORE_UNIT_MAP,
  STORE_UNIT_IDS,
  SET_UNIT_FUZZY_FILTER,
  STORE_ENTITY_API_URL,
  SET_UNIT_GROUP_FILTER,
  STORE_UNIT_GROUPS,
  SET_FILTER_ADJUSTING,
  // SET_ALL_GROUPS,
  // SET_ALL_UNITS,
  SET_SELECTED_GROUPS,
  SET_SELECTED_UNITS,
} from './action-names'
import {
  retrieveKpiSpec,
  retrieveContribElements,
  retrieveCAContribElements,
} from 'outage-analysis/actions'

export const action = (type, payload) => ({
  type,
  payload,
})

export const setFuzzyUnitFilter = text => dispatch => {
  dispatch(action(SET_FILTER_ADJUSTING, true))
  dispatch(action(SET_UNIT_FUZZY_FILTER, text))
  setTimeout(() => dispatch(action(SET_FILTER_ADJUSTING, false)), 200)
}

export const filterAdjusting = () => dispatch => {
  dispatch(action(SET_FILTER_ADJUSTING, true))
  setTimeout(() => dispatch(action(SET_FILTER_ADJUSTING, false)), 200)
}

export const retrieveUnitGroup = () => (dispatch, getState) => {
  const groupList = getUnitGroupList(getState())
  const groups = getUnitGroup(getState())
  if (groupList.length === 1) {
    const targetInfo = getEntityTargetInfo(getState())
    return entityApi
      .getUnitGroups(targetInfo)()
      .then(data => data.json())
      .then(groups => dispatch(action(STORE_UNIT_GROUPS, groups)))
  }
  return new Promise(resolve => resolve(groups))
}
export const retrieveUnitInfoMap = () => (dispatch, getState) => {
  const map = getUnitMap(getState())
  if (Object.keys(map).length === 0) {
    const targetInfo = getEntityTargetInfo(getState())
    return entityApi
      .getUnitNameMap(targetInfo)()
      .then(data => data.json())
      .then(map => dispatch(action(STORE_UNIT_MAP, map)))
  }
  return new Promise(resolve => resolve(map))
}

export const retrieveUnitList = () => (dispatch, getState) =>
  retrieveUnitInfoMap()(dispatch, getState).then(() => {
    const unitMap = getUnitMap(getState())
    const targetInfo = getEntityTargetInfo(getState())
    return entityApi
      .getUnitIds(targetInfo)()
      .then(data => data.json())
      .then(data => dispatch(action(STORE_UNIT_IDS, { data, unitMap })))
  })

export const storeSparkApiTarget = target =>
  action(STORE_ENTITY_API_URL, target)

export const setUnitGroupFilter = filter => dispatch => {
  dispatch(action(SET_FILTER_ADJUSTING, true))
  dispatch(action(SET_UNIT_GROUP_FILTER, filter))
  setTimeout(() => dispatch(action(SET_FILTER_ADJUSTING, false)), 200)
}

export const selectUnits = units => action(SET_SELECTED_UNITS, units)

export const selectGroups = groups => action(SET_SELECTED_GROUPS, groups)

export const setAllUnits = all => (dispatch, getState) =>
  dispatch(action(SET_SELECTED_UNITS, all ? getUnitIds(getState()) : []))

export const setAllGroups = all => (dispatch, getState) =>
  dispatch(
    action(SET_SELECTED_GROUPS, all ? Object.keys(getGroups(getState())) : [])
  )

export const loadAnalyticsEnvironment = _ => (dispatch, getState) => {
  retrieveKpiSpec()(dispatch, getState)
  retrieveContribElements()(dispatch, getState)
  retrieveCAContribElements()(dispatch, getState)
  // retrieveUnitGroup()(dispatch, getState)
}
